import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  z-index: 1;\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: white;\n  padding: 20px 32px;\n  display: none;\n  flex-direction: ",
        ";\n  gap: ",
        ";\n  transition: padding-bottom 0.2s ease-in-out;\n  border-top: 1px solid #e1e4ed;\n\n  .ant-btn {\n    width: 100%;\n    padding: 12px 20px;\n    flex: 1;\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n    line-height: 1.5;\n    letter-spacing: -0.16px;\n\n    .count {\n      margin-right: 4px;\n    }\n  }\n\n  dl {\n    margin: 0;\n    margin-right: 16px;\n\n    dd {\n      color: ",
        ";\n      font-size: 12px;\n      line-height: 1.5;\n    }\n\n    dt {\n      font-size: 20px;\n      font-weight: 700;\n      line-height: 1.5;\n      letter-spacing: -0.2px;\n    }\n  }\n\n  @media (max-width: ",
        "px) {\n    display: flex;\n  }\n  @media (max-width: ",
        "px) {\n    padding: 20px;\n    dl {\n      dd {\n        font-size: 12px;\n      }\n\n      dt {\n        font-size: 16px;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FilledButton from "@/components/common/Button/FilledButton";
import { getPassesUrlByAuthorId } from "@/components/edition/category/components/content/useProductItemHandlers";
import useEntitlementsQuery from "@/components/Package/PurchaseSection/useEntitlementsQuery";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { numberFormatter } from "@/lib/utils";
import { Button, Icon } from "@bookips/sds";
import { Stack, Typography } from "@mui/material";
import React, { useMemo } from "react";
import { useAppBarStore } from "src/store/appBar.store";
import useHandoutProductStore from "src/store/relatedProduct";
import styled from "styled-components";
import { HANDOUT_BREAK_POINT } from ".";
/** 무료체험 가능 여부 확인 (Case 1) */ const isEligibleForFreeTrial = (freeTrialData)=>{
    if (!freeTrialData) return false;
    return freeTrialData.isEligible || freeTrialData.reason === "not_logged_in";
};
/** 무료체험 끝 → 구매 유도 대상인지 확인 (Case 2) */ const isTrialOver = (freeTrialData)=>{
    if (!freeTrialData) return false;
    return freeTrialData.reason === "daily_limit_exceeded";
};
/** 무료획득으로 보유 → 사용 유도 대상인지 확인 (Case 3) */ const isAlreadyOwned = (freeTrialData)=>{
    if (!freeTrialData) return false;
    return freeTrialData.reason === "already_owned" && freeTrialData.isFreeOwned === true;
};
/** 유효한 이용권 보유 → 사용 유도 대상인지 확인 (Case 4) */ const hasValidMembership = (freeTrialData)=>{
    if (!freeTrialData) return false;
    return freeTrialData.reason === "already_owned" && freeTrialData.isFreeOwned === false;
};
/** 스켈레톤 컴포넌트 */ const FixedPurchaseSkeleton = ()=>/*#__PURE__*/ _jsx("div", {
        className: "flex h-12 w-full animate-pulse items-center justify-center rounded-lg bg-gray-100"
    });
export const FixedPurchaseSection = (param)=>{
    let { isFreepass , handoutType , freeTrialData , isFreeTrialLoading , productId , isLoggedIn , authorId  } = param;
    const { purchaseProductsInfo , openPassSectionModal  } = useHandoutProductStore((state)=>({
            purchaseProductsInfo: state.purchaseProductsInfo,
            openPassSectionModal: state.openPassSectionModal
        }));
    const isAppBarVisible = useAppBarStore((state)=>state.isVisible);
    const hasRelatedProducts = useMemo(()=>purchaseProductsInfo.selectedRelatedProducts.length > 0, [
        purchaseProductsInfo.selectedRelatedProducts
    ]);
    // 이용 가능한 이용권 확인 (main 브랜치 로직)
    // freepassOnly: false로 모든 이용권 타입 조회 (solvookplus, solvookplus-subscribe, ticket)
    const { data: passes = [] , isSuccess: isMembershipLoaded  } = useEntitlementsQuery({
        productId,
        isLoggedIn,
        freepassOnly: isFreepass,
        selectedPurchaseOption: "view",
        productHandoutType: handoutType
    });
    // 이용 가능한 이용권이 있는지 확인 (isDisabled가 false인 패스가 하나라도 있으면)
    const hasUsableMembership = isMembershipLoaded && passes.some((pass)=>!pass.isDisabled);
    const onClick = (buttonName, buttonType)=>{
        if (buttonType) {
            mixpanelEvent("CTA Button Clicked", {
                "Button Type": buttonType,
                "Button Name": buttonName,
                Position: "상품상세페이지 구매모듈"
            });
        }
        openPassSectionModal();
    };
    // 로딩 중일 때 스켈레톤 표시 (로그인 상태에서 membership 데이터가 아직 로드되지 않았으면 대기)
    if (isFreeTrialLoading || isLoggedIn && !isMembershipLoaded) {
        return /*#__PURE__*/ _jsx(FixedSection, {
            $isAppBarVisible: isAppBarVisible,
            children: /*#__PURE__*/ _jsx(FixedPurchaseSkeleton, {})
        });
    }
    // Case 1: 무료체험 가능한 경우
    if (isEligibleForFreeTrial(freeTrialData)) {
        // Case 1-1: 이용 가능한 이용권이 있으면 이용권 선택 UI 표시 (main 브랜치 로직)
        if (hasUsableMembership) {
            return /*#__PURE__*/ _jsx(FixedSection, {
                $isAppBarVisible: isAppBarVisible,
                children: /*#__PURE__*/ _jsx(FilledButton, {
                    type: "text",
                    variant: "solid",
                    onClick: ()=>onClick("이용권 사용하기", "case1-1)이용권 보유한 무료체험 대상 유저"),
                    children: "이용권 사용하기"
                })
            });
        }
        // Case 1-2: 이용권이 없으면 무료로 받기
        const handleFreeTrialClick = ()=>{
            onClick("무료로 받기", "case1-2)무료체험 유도할 유저");
        };
        const handlePurchaseClick = ()=>{
            const buttonUrl = getPassesUrlByAuthorId(authorId);
            mixpanelEvent("CTA Button Clicked", {
                "Button Type": "case1-2)무료체험 유도할 유저",
                "Button Name": "패스 구매하고 무제한 이용하기",
                "Button URL": buttonUrl,
                Position: "상품상세페이지 구매모듈"
            });
            window.open(buttonUrl, "_blank");
        };
        return /*#__PURE__*/ _jsxs(FixedSection, {
            $isAppBarVisible: isAppBarVisible,
            $isColumn: true,
            children: [
                /*#__PURE__*/ _jsx(FilledButton, {
                    type: "text",
                    variant: "solid",
                    onClick: handleFreeTrialClick,
                    children: "무료로 받기"
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "text",
                    color: "primary",
                    size: "sm",
                    fullWidth: true,
                    rightElement: /*#__PURE__*/ _jsx(Icon.ArrowRight_2px, {
                        className: "text-primary-main size-4.5"
                    }),
                    onClick: handlePurchaseClick,
                    children: "패스 구매하고 무제한 이용하기"
                })
            ]
        });
    }
    // Case 2: 무료체험 끝 → 구매 유도 (다이얼로그 열기)
    if (isTrialOver(freeTrialData)) {
        return /*#__PURE__*/ _jsx(FixedSection, {
            $isAppBarVisible: isAppBarVisible,
            children: /*#__PURE__*/ _jsx(FilledButton, {
                type: "text",
                variant: "solid",
                onClick: ()=>onClick("즉시 무제한 이용하기", "case2)무료체험 종료 후 구매 유도할 유저"),
                children: "즉시 무제한 이용하기"
            })
        });
    }
    // Case 3: 무료체험으로 보유 → 사용 유도 (다이얼로그 열기)
    if (isAlreadyOwned(freeTrialData)) {
        return /*#__PURE__*/ _jsx(FixedSection, {
            $isAppBarVisible: isAppBarVisible,
            children: /*#__PURE__*/ _jsx(FilledButton, {
                type: "text",
                variant: "solid",
                onClick: ()=>onClick("자료 이용하기", "case3)무료체험으로 자료 획득한 유저"),
                children: "자료 이용하기"
            })
        });
    }
    // Case 4: 유효한 이용권 보유 → 사용 유도 (다이얼로그 열기)
    if (hasValidMembership(freeTrialData)) {
        return /*#__PURE__*/ _jsx(FixedSection, {
            $isAppBarVisible: isAppBarVisible,
            children: /*#__PURE__*/ _jsx(FilledButton, {
                type: "text",
                variant: "solid",
                onClick: ()=>onClick("자료 이용하기", "case4)이용권을 보유한 유저"),
                children: "자료 이용하기"
            })
        });
    }
    if (isFreepass) {
        return /*#__PURE__*/ _jsx(FixedSection, {
            $isAppBarVisible: isAppBarVisible,
            children: /*#__PURE__*/ _jsx(FilledButton, {
                type: "text",
                variant: "solid",
                onClick: ()=>onClick("이용권 사용하기"),
                children: "이용권 사용하기"
            })
        });
    }
    const buttonName = hasRelatedProducts ? "".concat(purchaseProductsInfo.totalCount, "개 구매하기") : "구매하기";
    return /*#__PURE__*/ _jsxs(FixedSection, {
        $isAppBarVisible: isAppBarVisible,
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                sx: {
                    mr: 2,
                    justifyContent: "center"
                },
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "caption",
                        color: "text.secondary",
                        children: hasRelatedProducts ? "합계 금액" : "판매가"
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        variant: "subtitle1",
                        color: "text.title",
                        children: [
                            numberFormatter(purchaseProductsInfo.totalPrice),
                            "원"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(FilledButton, {
                type: "text",
                variant: "solid",
                onClick: ()=>onClick(buttonName, "case5)무료체험이 아닌 일반구매 유도할 유저"),
                children: [
                    hasRelatedProducts && /*#__PURE__*/ _jsxs("span", {
                        className: "count",
                        children: [
                            purchaseProductsInfo.totalCount,
                            "개 "
                        ]
                    }),
                    "구매하기"
                ]
            })
        ]
    });
};
const FixedSection = styled.div.withConfig({
    componentId: "sc-2b18ebd2-0"
})(_templateObject(), (props)=>props.$isColumn ? "column" : "row", (props)=>props.$isColumn ? "8px" : "0", (props)=>props.theme.new.colors.sol_gray_500, HANDOUT_BREAK_POINT.TABLET, HANDOUT_BREAK_POINT.MOBILE);
